// Theme change
// Toggles the sibling-thumbnail row: "+" expands the list into an overlay
// over the card, the same button (now "−") or mouseleave collapses it.
// `is-collapsing` keeps the overlay absolutely positioned while the
// thumbnails shrink, so collapsing animates instead of snapping.
// why: HUSHOP-82 caps color thumbnails at N on product cards.
document.addEventListener('click', (event) => {
  const button = event.target.closest('.siblings-thumbnails__more-button');
  if (!button) return;

  event.preventDefault();
  const list = button.closest('.siblings-thumbnails__list');

  const collapse = () => {
    list.removeEventListener('mouseleave', collapse);
    list.classList.add('is-collapsing');
    list.classList.remove('is-expanded');
    button.setAttribute('aria-expanded', 'false');

    const done = () => {
      list.removeEventListener('transitionend', onEnd);
      list.classList.remove('is-collapsing');
    };
    const onEnd = (transitionEvent) => {
      if (transitionEvent.propertyName === 'inline-size') done();
    };
    list.addEventListener('transitionend', onEnd);
    // ponytail: backstop for reduced-motion/zero-duration where transitionend never fires
    setTimeout(done, 400);
  };

  if (list.classList.contains('is-expanded')) {
    collapse();
    return;
  }

  list.classList.remove('is-collapsing');
  list.classList.add('is-expanded');
  button.setAttribute('aria-expanded', 'true');
  list.addEventListener('mouseleave', collapse, { once: true });
});
